const config = {
    API_URL: import.meta.env.VITE_API_URL,
    MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB in bytes
    ALLOWED_FILE_TYPES: ['.pdf', '.ppt', '.pptx'],
};

// Validate required configuration
if (!config.API_URL) {
    throw new Error('API_URL is not configured. Please set VITE_API_URL environment variable.');
}

export default config;
